import React from "react";

const EventClockIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <path d="M7.99479 1.33398C4.32812 1.33398 1.32812 4.33398 1.32812 8.00065C1.32812 11.6673 4.32812 14.6673 7.99479 14.6673C11.6615 14.6673 14.6615 11.6673 14.6615 8.00065C14.6615 4.33398 11.6615 1.33398 7.99479 1.33398ZM7.99479 13.334C5.05479 13.334 2.66146 10.9407 2.66146 8.00065C2.66146 5.06065 5.05479 2.66732 7.99479 2.66732C10.9348 2.66732 13.3281 5.06065 13.3281 8.00065C13.3281 10.9407 10.9348 13.334 7.99479 13.334ZM8.32812 4.66732H7.32812V8.66732L10.7948 10.8007L11.3281 9.93398L8.32812 8.13398V4.66732Z" fill="#707070"/>
  </svg>
);

export default EventClockIcon;